/* eslint-disable indent */
import styled from 'styled-components';
import { Space, Text, Paper } from '@cashfree-intl/coherent';

export const StyledPaper = styled(Paper)`
  margin-bottom: 2px;
`;

export const StyledOpenNewTab = styled.div`
  margin-bottom: 2px;
  cursor: pointer;
`;
export const StyledDetailsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: 150px;
`;
export const StyledDetailsObject = styled(Space)`
  flex: 50%;
`;
export const StyledDisplayText = styled(Text)`
  min-width: 180px;
`;
export const StyledStatusText = styled(Text)`
  ${({ status }) => {
    const bgMap = {
      ACTIVE: {
        'background-color': '#D9F1E0',
      },
      ON_HOLD: {
        'background-color': '#F9ECDA',
      },
      BLOCKED: {
        'background-color': '#F7DFDF',
      },
      DELETED: {
        'background-color': '#F7DFDF',
      },
      BANK_VALIDATION_FAILED: {
        'background-color': '#F9ECDA',
        color: '#D68309',
      },
      IN_BANK_VALIDATION: {
        'background-color': '#F9ECDA',
        color: '#D68309',
      },
      ACTION_REQUIRED: {
        'background-color': '#F7DFDF',
        color: '#CB2C2C',
      },
      IN_KYC_REVIEW: {
        'background-color': '#F9ECDA',
        color: '#D68309',
      },
      default: {
        'background-color': '#FFF',
      },
    };
    const styles = bgMap[status] || bgMap.default;
    return Object.keys(styles)
      .map(key => `${key}: ${styles[key]};`)
      .join('');
  }};
  padding: 2px 6px;
`;
export const StyledBackText = styled(Text)`
  display: inline-block;
  margin-top: 2px;
  cursor: pointer;
`;
export const StyledCopyToClipboard = styled.div`
  cursor: pointer;
`;

export const StyledDetailedValue = styled(Text)`
  max-width: 25%;
`;
